import React, { useState } from "react";
import styles from "./filter-select.module.css";
import { useDispatch, useSelector } from "react-redux";
import { v4 } from "uuid";
import { createPortal } from "react-dom";
import { LOCALES } from "../../constants";

export default function FilterSelect({
    id,
    list,
    selected,
    changeFilter,
    showName = true,
    isUseDispatch = true,
    disableBorderRadius = false,
    forceWidth = undefined,
    forceSmallPadding = false,
    mode = "dropdown",
}) {
    const lang = useSelector((state) => state.lang.value);

    const [isActive, setIsActive] = useState(false);

    const dispatch = useDispatch();

    let kor = "";
    let eng = "";
    if (id === "rarity") {
        kor = "등급";
        eng = "Grade";
    } else if (id === "attr") {
        kor = "속성";
        eng = "Attribute";
    } else if (id === "class") {
        kor = "클래스";
        eng = "Class";
    } else if (id === "status") {
        kor = "메인 스탯";
        eng = "Main Stat";
    } else if (id === "weather") {
        kor = "날씨 이벤트를 선택하세요";
        eng = "Select Weather Event";
    } else if (id === "arcana") {
        kor = "아르카나를 선택하세요";
        eng = "Select Arcana";
    } else if (id === "item_type") {
        kor = "종류";
        eng = "Item Type";
    } else if (id === "item_sort") {
        kor = "기본 정렬";
        eng = "Default Order";
    } else if (id === "journey_difficulty") {
        kor = "난이도";
        eng = "Difficulty";
    } else if (id === "savior_simulator_select_savior") {
        kor = "구원자 선택";
        eng = "Select Savior";
    } else if (id === "potential_type") {
        kor = "종류";
        eng = "Type";
    } else if (id === "potential_role") {
        kor = "역할";
        eng = "Role";
    }

    const dispatchFilter = (obj) => {
        if (isUseDispatch) {
            if (typeof obj === "string") {
                dispatch(changeFilter(obj));
            } else {
                dispatch(changeFilter({ id, obj }));
            }
        } else {
            changeFilter(obj);
        }
        setIsActive(false);
    };

    const width = forceWidth ? { minWidth: forceWidth } : {};

    return (
        <div
            className={`${styles["select-wrapper"]} ${id === "arcana" || id === "weather" ? `${styles["schedule-arcana"]}` : ""} ${disableBorderRadius ? "" : `${styles["border-radius"]}`} ${isActive ? `${styles["active"]}` : ""} ${forceSmallPadding ? `${styles["small-padding"]}` : ""}`}
            style={width}
            onClick={() => setIsActive(!isActive)}
        >
            <div className={`${styles["title"]} ${showName && selected.value === "all" ? "" : `${styles["disabled"]}`}`}>
                {lang === LOCALES.KO ? kor : eng}
            </div>
            {/* <div className={`${styles["title"]} ${!showName || selected.value !== "all" ? `${styles["disabled"]}` : ""}`}>:</div> */}
            {typeof selected === "object" && selected.value !== "all" && (
                <div className={styles["represent"]}>{list.find((item) => item.value === selected.value)?.name}</div>
            )}
            {typeof selected === "string" && (
                <div className={styles["represent"]}>{list.find((item) => item.value === selected)?.name || selected}</div>
            )}
            {mode === "dropdown" && (
                <div className={`${styles["list"]}`}>
                    {list.map((element) => {
                        return (
                            <div className={styles["element"]} onClick={() => dispatchFilter(element)} key={`${v4()}`}>
                                {element.name || element}
                            </div>
                        );
                    })}
                </div>
            )}
            {mode === "modal" &&
                createPortal(
                    <div
                        className={`modal fit ${isActive ? `active` : ""}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (e.target.classList.contains("modal")) {
                                setIsActive(!isActive);
                            }
                        }}
                    >
                        <div className="window">
                            <button
                                className="close-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsActive(false);
                                }}
                            >
                                <i className="fi fi-sr-x" />
                            </button>
                            <div className={`${styles["modal-list-container"]}`}>
                                <div className={`${styles["list"]}`}>
                                    {list.map((element) => {
                                        return (
                                            <div className={styles["element"]} onClick={() => dispatchFilter(element)} key={`${v4()}`}>
                                                {element.name || element}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>,
                    document.getElementById("portal-root"),
                )}
        </div>
    );
}
